module.exports = __webpack_public_path__ + "img/icon_creation2.f70eb44f.svg";